
import { CipherQuestion } from '../cipherTypes';

interface QuizQuestionProps {
  question: CipherQuestion;
  selectedOption: string | null;
  selectedOptions: string[];
  isMultiSelect: boolean;
  requiredSelections: number;
  onOptionSelect: (option: string) => void;
}

const QuizQuestion = ({ 
  question, 
  selectedOption, 
  selectedOptions, 
  isMultiSelect, 
  requiredSelections,
  onOptionSelect 
}: QuizQuestionProps) => {
  return (
    <div className="mb-8">
      <h3 className="text-xl font-semibold text-tan mb-4">{question.question}</h3>
      
      {question.hint && (
        <div className="bg-tan-dark/20 border-l-4 border-tan p-3 mb-4">
          <p className="text-sm text-tan-dark">💡 <strong>Hint:</strong> {question.hint}</p>
        </div>
      )}
      
      {isMultiSelect && (
        <div className="mb-4 p-3 bg-navy-dark rounded-lg border border-tan-dark">
          <p className="text-tan font-bold text-sm">
            📋 Select exactly {requiredSelections} options ({selectedOptions.length}/{requiredSelections} selected)
          </p>
        </div>
      )}
      
      <div className="space-y-3">
        {question.options.map((option) => (
          <div 
            key={option}
            onClick={() => onOptionSelect(option)}
            className={`group p-4 border rounded-lg cursor-pointer transition-all flex items-center space-x-3 ${
              isMultiSelect
                ? selectedOptions.includes(option)
                  ? 'bg-tan border-tan text-navy font-medium shadow-md'
                  : 'border-tan-dark hover:bg-navy-dark hover:border-tan/50 hover:shadow-sm'
                : selectedOption === option
                  ? 'bg-tan border-tan text-navy font-medium shadow-md'
                  : 'border-tan-dark hover:bg-navy-dark hover:border-tan/50 hover:shadow-sm'
            }`}
          >
            {isMultiSelect ? (
              <div className={`w-5 h-5 border-2 rounded flex items-center justify-center transition-all ${
                selectedOptions.includes(option) 
                  ? 'border-navy bg-navy shadow-sm' 
                  : 'border-tan-dark group-hover:border-tan/70'
              }`}>
                {selectedOptions.includes(option) && (
                  <svg className="w-3 h-3 text-tan font-bold" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                )}
              </div>
            ) : (
              <div className={`w-5 h-5 border-2 rounded-full transition-all ${
                selectedOption === option 
                  ? 'border-navy bg-navy shadow-sm' 
                  : 'border-tan-dark group-hover:border-tan/70'
              }`}>
                {selectedOption === option && (
                  <div className="w-3 h-3 rounded-full bg-tan m-0.5"></div>
                )}
              </div>
            )}
            <span>{option}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuizQuestion;
